import { render, staticRenderFns } from "./AbsenteeGroup.vue?vue&type=template&id=b61d1dd8&"
import script from "./AbsenteeGroup.vue?vue&type=script&lang=js&"
export * from "./AbsenteeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports